import React from 'react'

import { PersonAvatar } from '@sketch/components'
import { thumbnailForPreviewFile } from '@sketch/modules-common'
import { AddShareMemberNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import { DocumentTileMedia } from './DocumentTileMedia'
import { AcceptAction } from './InboxPreviewActions'
import {
  Card,
  Separator,
  Tile,
  TileTitle,
  TileWrapper,
  RoleBadge,
  TileMeta,
} from './TileCard.styles'

interface AddShareMemberPreviewProps {
  notification: AddShareMemberNotificationFragment
}

export const AddShareMemberPreview = ({
  notification,
}: AddShareMemberPreviewProps) => {
  const { share, user, workspace } = notification

  if (!share || !user) return null

  const name = user.name ?? 'Someone'
  const avatarSrc = user.avatar?.small
  const hasPendingInvite = share.userHasUnacceptedInvitationToView

  const thumbnail = thumbnailForPreviewFile(share.previewFiles?.[0])

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {avatarSrc ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={name}
                src={avatarSrc}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={name} />
            )}
          </AvatarWrapper>
          <TileTitle>{name}</TileTitle>
          <RoleBadge variant="secondary">Inviter</RoleBadge>
        </Tile>

        <Separator />

        <Tile>
          <DocumentTileMedia src={thumbnail} alt={`Preview of ${share.name}`} />
          <TileTitle>{share.name}</TileTitle>
          {share.project?.name && <TileMeta>{share.project.name}</TileMeta>}
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>

      {hasPendingInvite && <AcceptAction shareIdentifier={share.identifier} />}
    </Card>
  )
}
